import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#arcgis-map')

if (mountEl) {
	createApp(App, { data: (mountEl as HTMLElement).dataset }).mount(
		'#arcgis-map'
	)
} else {
	console.error("Element '#arcgis-map' not found")
}
